import React from 'react';
import { SmallButtonStyle, ButtonsContainerStyle, SmallButtonLinkStyle, ButtonIcon } from './styles';

export const ButtonsContainer = ({ padding, alignCenter, children }) => {
  return (
    <ButtonsContainerStyle padding={padding} alignCenter={alignCenter}>
      {children}
    </ButtonsContainerStyle>
  );
};

export const SmallButton = ({ onClick, isRedButton, iconName, label }) => (
  <SmallButtonStyle onClick={onClick} primaryRed={isRedButton}>
    {iconName && <ButtonIcon icon={iconName} />}
    {label}
  </SmallButtonStyle>
);

export const SmallButtonLink = ({ link, isRedButton, iconName, label }) => (
  <SmallButtonLinkStyle href={link}>
    <SmallButtonStyle primaryRed={isRedButton}>
      {iconName && <ButtonIcon icon={iconName} />}
      {label}
    </SmallButtonStyle>
  </SmallButtonLinkStyle>
);
